export default (state, action) => {
  switch (action.type) {
    case 'changeFloor':
      return {
        ...state,
        floor: Number(action.floor),
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-search/reducer.js